/* eslint-disable space-before-blocks */
/* eslint-disable no-return-assign */
/* eslint-disable comma-dangle */
/* eslint-disable spaced-comment */
/* eslint-disable padded-blocks */
/* eslint-disable no-dupe-keys */
/* eslint-disable quotes */
/* eslint-disable space-before-function-paren */
/* eslint-disable no-useless-return */
/* eslint-disable semi */
/* eslint-disable no-tabs */
import CoverageAreaList from "./coverageAreaList.vue";
import CoverageAreaLocationList from "./coverageAreaLocationList.vue";
import coverageAreaListDetail from "./coverageAreaListDetail.vue";
import i18n from "../../../i18n/index.js";
import locationService from "../../../services/location/LocationService.js";
import createCoverageArea from "../../../services/branch/coverageArea/coverageArea.js";
import branchService from "../../../services/branch/BranchService.js";

export default {
  data: () => ({
    rules: { required: (value) => !!value || i18n.t("field-required") },
    showDetail: false,
    branchCitiesDetail: [],
    colorValidate: null,
    dataCoverageArea: null,
    validateCitie: null,
    hideList: false,
    location: {
      state: "",
      city: "",
      branche_id: null,
    },
    branch: {
      editFunction: false,
      id: "",
      name: "",
      branchId: "",
      providerId: "",
      type: "",
      branchCities: [],
      listCities: [],
      inactiveCities: [],
      newBranches: [],
    },
    branches: [],
    states: [],
    cities: [],
  }),
  components: {
    CoverageAreaList,
    CoverageAreaLocationList,
    coverageAreaListDetail,
  },
  methods: {
    showFunction() {
      this.hideList = false;
      this.showDetail = false;
    },
    async onRowClick(item) {
      await this.getBranches();
      await this.getStates();

      this.branch.branchId = item.id;
      this.branches = this.branches.filter((b) => b.id == this.branch.branchId);
      this.branch.branchCities = item.branchCities.map((obj) => {
        return {
          code: obj.idCity.code,
          id: obj.idCity.id,
          name: obj.idCity.name,
          idState: {
            code: obj.idCity.idState.code,
            id: obj.idCity.idState.id,
            name: obj.idCity.idState.name,
          },
        };
      });
      this.$refs.areaDetail.addData(item);
      this.branch.editFunction = true;
      this.showDetail = true;
      this.hideList = true;
      // this.branchCitiesDetail = item
    },
    closeCreate() {
      this.hideList = false;
      this.branch.editFunction = false;
      this.branch.branchId = null;
      this.branch.branchCities = [];
      this.branch.listCities = [];
      this.branch.inactiveCities = [];
      this.showFunction();
    },
    create() {
      /*if (!this.$refs.branchForm.validate()) {
			  this.$notify({
				group: "app",
				type: "error",
				text: i18n.t("app.error-required-fields")
			  });
			  return;
			} */

      if (this.branch.branchCities.length === 0) {
        this.$notify({
          group: "app",
          type: "error",
          text: i18n.t("branches.error-no-city"),
        });
        return;
      }
      createCoverageArea
        .createCoverageArea(this.branch)
        .then((res) => {
          this.$refs.coverageAreaList.get();
          this.$notify({
            group: "app",
            type: "success",
            text: i18n.t("record-successfully-created"),
          });
          this.closeCreate();
        })
        .catch((error) => {
          if (error && error.code) {
            const errorCode = error.code;

            if (errorCode === "COVERAGE_OVERLAY") {
              this.$notify({
                group: "app",
                type: "error",
                text: i18n.t("branches.error-coverage-overlay"),
              });
            }
            if (errorCode === "EXISTING_BRANCH_CITY") {
              this.$notify({
                group: "app",
                type: "error",
                text: i18n.t("EXISTING_BRANCH_CITY"),
              });
            }
            if (errorCode === "HAS_SHIPPING_FEE") {
              this.$notify({
                group: "app",
                type: "error",
                text: i18n.t("HAS_SHIPPING_FEE"),
              });
            }
          }
        });
    },
    addCity(city) {
      if (!this.$refs.branchForm.validate()) {
        this.$notify({
          group: "app",
          type: "error",
          text: i18n.t("app.error-required-fields"),
        });
        return;
      }
      let cityToAdd = city;

      if (!city) {
        if (this.location.city === "") return;
        cityToAdd = this.cities.find((c) => c.id === this.location.city);
      }

      if (this.branch.branchCities.some((c) => c.id === cityToAdd.id)) {
        this.$notify({
          group: "app",
          type: "error",
          text: i18n.t("branches.error-city-already-in-branch"),
        });
        return;
      }
      createCoverageArea
        .validateCitie(
          this.branch.branchId,
          this.branch.editFunction,
          this.location.city,
          this.location.state
        )
        .then((res) => {
          this.validateCitie = res.data;
          if (this.validateCitie === "La sede seleccionada ya existe") {
            this.colorValidate = "error";
          } else if (
            this.validateCitie ===
            "El municipio seleccionado está asociado a otra sede del prestador"
          ) {
            this.colorValidate = "error";
          }
          if (this.validateCitie === "Guardado con éxito") {
            this.colorValidate = "success";
            this.branch.newBranches.push(cityToAdd);
            this.branch.listCities.push(cityToAdd);
            this.branch.branchCities.push(cityToAdd);
            this.location.state = "";
            this.location.city = "";
            this.cities = [];
            this.$emit("pushData", this.branchCities);
          }
          if (this.validateCitie === "") {
            return;
          }
          this.$notify({
            group: "app",
            type: this.colorValidate,
            text: this.validateCitie,
          });
          console.log(res);
        });
    },
    async getBranches() {
      let response = await branchService.allBranches();
      this.branches = response.data[0];
    },
    // async showCreate() {
    // 	await this.getBranches()
    // 	await this.getStates()
    // 	this.hideList = true
    // },
    // async getStates() {
    // 	await locationService.getStatesByCountry().then(response => {
    // 		this.states = response.data
    // 		this.location.state = ''
    // 		this.location.city = ''
    // 	})
    // },
    // getCities() {
    // 	locationService.getCitiesByState(this.location.state).then(response => {
    // 		this.cities = response.data
    // 		this.location.city = ''
    // 	})
    // },
    deletebranchCitiesDetail(itm) {
      let cityToInactive = itm;
      if (!itm) {
        if (this.location.city === "") return;
        cityToInactive = this.cities.find((c) => c.id === this.location.city);
      }

      this.branch.inactiveCities.push(cityToInactive);
    },
    async showCreate() {
      await this.getBranches();
      await this.getStates();
      this.hideList = true;
      this.branch.editFunction = false;
    },
    async getStates() {
      await locationService.getStatesByCountry().then((response) => {
        this.states = response.data;
        this.location.state = "";
        this.location.city = "";
      });
    },
    getCities() {
      locationService.getCitiesByState(this.location.state).then((response) => {
        this.cities = response.data;
        this.location.city = "";
      });
    },
  },
};
